import { ref as l, computed as p, onMounted as _, nextTick as d, openBlock as m, createElementBlock as f, normalizeStyle as v, createVNode as s, unref as i, withCtx as u, createTextVNode as k, createCommentVNode as y } from "vue";
import { CdrButton as B, IconArrowUp as h } from "@rei/cedar";
const T = (o, n) => {
  const e = o.__vccOpts || o;
  for (const [t, c] of n)
    e[t] = c;
  return e;
}, g = {
  __name: "BackToTopBtn",
  props: {
    minHeightMultiplier: {
      type: Number,
      default: 4
    },
    scrollMultiplier: {
      type: Number,
      default: 0.67
    }
  },
  setup(o) {
    const n = o, e = l(!1), t = l(0), c = p(() => ({
      "--scroll-amount": `${t.value * n.scrollMultiplier}px`
    })), a = () => {
      t.value = document.documentElement.offsetHeight;
      const r = parseInt(window.innerHeight, 10);
      e.value = t.value >= r * n.minHeightMultiplier;
    };
    return _(async () => {
      await d(), a(), new ResizeObserver(() => {
        a();
      }).observe(document.documentElement);
    }), (r, b) => e.value ? (m(), f("div", {
      key: 0,
      class: "back-to-top",
      style: v(c.value)
    }, [s(i(B), {
      class: "back-to-top__inner",
      "aria-label": "Back to top",
      modifier: "dark",
      tag: "a",
      href: "#"
    }, {
      "icon-left": u(() => [s(i(h), {
        "inherit-color": ""
      })]),
      default: u(() => [k(" TOP ")]),
      _: 1
    })], 4)) : y("", !0);
  }
}, H = /* @__PURE__ */ T(g, [["__scopeId", "data-v-14af1632"]]);
export {
  H as default
};
